import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map, debounceTime } from 'rxjs/operators';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';
import {
  CreditCardTransactionsService,
  ICreditCardTransaction
} from './../../services/credit-card-transactions.service';

@Component({
  selector: 'ab-credit-card-transaction-overview',
  templateUrl: './credit-card-transaction-overview.component.html',
  styleUrls: ['./credit-card-transaction-overview.component.scss']
})
export class CreditCardTransactionOverviewComponent
  implements OnInit, OnDestroy {
  @Input() rendering: ComponentRendering;
  public subscription: Subscription;
  public transactions: Array<ICreditCardTransaction> = [];
  public isLoading: boolean;
  public id: string;
  public hasMore = false;
  private pageNumber = 1;

  constructor(
    private route: ActivatedRoute,
    private creditCardTransactionsService: CreditCardTransactionsService
  ) {}

  ngOnInit() {
    this.subscription = this.route.queryParams
      .pipe(
        filter(params => 'id' in params),
        map(params => params.id),
        debounceTime(100)
      )
      .subscribe(id => {
        this.id = id;
        this.getTransactions(id);
      });
  }

  getTransactions(id: string): void {
    this.isLoading = true;
    this.creditCardTransactionsService
      .getTransaction(id, this.pageNumber)
      .subscribe(response => {
        this.isLoading = false;
        this.transactions = [...this.transactions, ...response.transactions];
        this.hasMore = response.transactions.length === response.pageSize;
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onScroll() {
    if (!this.isLoading) {
      this.pageNumber++;
      this.getTransactions(this.id);
    }
  }
}
